<script setup lang="ts">
const { currentTime, currentDuration: max, isFullscreen } = storeToRefs(useAudioStore())

const backgroundSize = computed(() => {
  const min = 0
  return `${((currentTime.value - min) / (max.value - min)) * 100}% 100%`
})

function seek(e: Event) {
  const target = e.target as HTMLInputElement
  currentTime.value = Number(target.value)
}
</script>

<template>
  <div
    class="flex w-full items-center justify-center gap-4 2xl:mx-10"
    :class="{
      'flex-row-reverse ': isFullscreen,
    }"
  >
    <UAudioPlaybackSpeed />
    <div class="flex w-full items-center justify-center gap-2">
      <span class="text-label-xs w-16 text-white" v-text="getMinutesAndSeconds(currentTime)" />
      <input
        :value="currentTime"
        aria-label="Lydglider"
        type="range"
        :min="0"
        :max="max"
        step="0.01"
        class="h-[2px] w-full min-w-32 !max-w-[90%] cursor-pointer appearance-none bg-[var(--theme-translucent-light)] bg-[linear-gradient(#FFFFFF,#FFFFFF)] bg-no-repeat opacity-80 transition-opacity duration-200 hover:opacity-100"
        @input="seek"
      />
      <span class="text-label-xs w-16 text-white" v-text="getMinutesAndSeconds(max)" />
    </div>
  </div>
</template>

<style scoped lang="postcss">
input[type="range"] {
  background-size: v-bind(backgroundSize);
}

input[type="range"]::-webkit-slider-thumb {
  @apply h-[15px]
  w-[15px] appearance-none rounded-full bg-white;
}

input[type="range"]::-moz-range-thumb {
  @apply h-[15px] w-[15px] appearance-none rounded-full bg-white border-none;
}
</style>
